import { useMutation, useQueryClient } from "react-query";
import { updateOfficeBank } from "../../../../../actions/Utilities/OfficeBank";

const useEditOfficeBank = () => {
  return useMutation(updateOfficeBank);
};

export default useEditOfficeBank;
